// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/stakeholders/firstparty/v1/create_stakeholder.proto

/* eslint-disable */
import { ApiTimestamp } from "../../../../../google/protobuf/timestamp";
import {
  ApiGender,
  apiGenderFromJSON,
  apiGenderToJSON,
  ApiRole,
  apiRoleFromJSON,
  apiRoleToJSON,
  ApiStakeholder,
} from "./stakeholder";

/** Request message for creating a stakeholder */
export interface ApiCreateStakeholderRequest {
  /** The stakeholder data to create */
  readonly stakeholder: ApiStakeholderInput | null;
}

/** Response message for creating a stakeholder */
export interface ApiCreateStakeholderResponse {
  /** The created stakeholder */
  readonly stakeholder: ApiStakeholder | null;
}

/** Input message for creating/updating a stakeholder */
export interface ApiStakeholderInput {
  /** Organization ID associated with the stakeholder */
  readonly organizationId?:
    | string
    | null
    | undefined;
  /** The title-key the stakeholder holds in their organization */
  readonly title?:
    | string
    | null
    | undefined;
  /** The gender of the stakeholder */
  readonly gender?:
    | ApiGender
    | null
    | undefined;
  /** The first name of the stakeholder */
  readonly firstName?:
    | string
    | null
    | undefined;
  /** The last name of the stakeholder */
  readonly lastName?:
    | string
    | null
    | undefined;
  /** The email of the stakeholder */
  readonly email?:
    | string
    | null
    | undefined;
  /** The phone number of the stakeholder */
  readonly phoneNumber?:
    | string
    | null
    | undefined;
  /** The locale setting of the stakeholder */
  readonly locale?:
    | string
    | null
    | undefined;
  /** The timezone setting of the stakeholder */
  readonly timezone?:
    | string
    | null
    | undefined;
  /** The birthdate of the stakeholder */
  readonly birthdate?:
    | Date
    | null
    | undefined;
  /** The 1st line of the address of the stakeholder */
  readonly addressLine1?:
    | string
    | null
    | undefined;
  /** The 2nd line of the address of the stakeholder */
  readonly addressLine2?:
    | string
    | null
    | undefined;
  /** The zipcode of the address of the stakeholder */
  readonly addressZipcode?:
    | string
    | null
    | undefined;
  /** The city of the address of the stakeholder */
  readonly addressCity?:
    | string
    | null
    | undefined;
  /** The country of the address of the stakeholder */
  readonly addressCountry?:
    | string
    | null
    | undefined;
  /** The birth zipcode of the stakeholder */
  readonly birthZipcode?:
    | string
    | null
    | undefined;
  /** The birth city of the stakeholder */
  readonly birthCity?:
    | string
    | null
    | undefined;
  /** The birth country of the stakeholder */
  readonly birthCountry?:
    | string
    | null
    | undefined;
  /** The nationality of the stakeholder */
  readonly nationality?:
    | string
    | null
    | undefined;
  /** The role of the stakeholder */
  readonly role?:
    | ApiRole
    | null
    | undefined;
  /** Whether the stakeholder is a shareholder */
  readonly shareholder?:
    | boolean
    | null
    | undefined;
  /** Capital amount for FR k-deposit, in cents */
  readonly capitalAmountCents?:
    | number
    | null
    | undefined;
  /** Whether the stakeholder gave power of attorney */
  readonly gavePower?:
    | boolean
    | null
    | undefined;
  /** Whether the stakeholder is empowered */
  readonly powered?:
    | boolean
    | null
    | undefined;
  /** Whether the stakeholder is a UBO */
  readonly ubo?:
    | boolean
    | null
    | undefined;
  /** Whether the stakeholder is a corporate officer */
  readonly corporateOfficer?:
    | boolean
    | null
    | undefined;
  /** The Italian fiscal code */
  readonly italianFiscalCode?:
    | string
    | null
    | undefined;
  /** Whether this person is a tax payer in the United States */
  readonly usTaxPayer?:
    | boolean
    | null
    | undefined;
  /** Whether this person is a tax payer in country different from the legal country of the organization */
  readonly taxPayerOutsideLegalCountry?:
    | boolean
    | null
    | undefined;
  /** Whether the domicile address is the same as the address */
  readonly domicileSameAsResidence?:
    | boolean
    | null
    | undefined;
  /** The 1st line of the domicile address of the stakeholder */
  readonly domicileLine1?:
    | string
    | null
    | undefined;
  /** The 2nd line of the domicile address of the stakeholder */
  readonly domicileLine2?:
    | string
    | null
    | undefined;
  /** The zipcode of the domicile address of the stakeholder */
  readonly domicileZipcode?:
    | string
    | null
    | undefined;
  /** The city of the domicile address of the stakeholder */
  readonly domicileCity?:
    | string
    | null
    | undefined;
  /** The country of the domicile address of the stakeholder */
  readonly domicileCountry?:
    | string
    | null
    | undefined;
  /** The sources of wealth of the stakeholder */
  readonly sourcesOfWealth: readonly string[];
  /** The freeform text for the stakeholder's sources of wealth */
  readonly sourcesOfWealthOther?:
    | string
    | null
    | undefined;
  /** Whether the stakeholder has specified any additional sources of wealth */
  readonly hasSourcesOfWealth?:
    | boolean
    | null
    | undefined;
  /** Whether the stakeholder is a politically exposed person (PEP) */
  readonly politicallyExposedPerson?:
    | boolean
    | null
    | undefined;
  /** The nationalities of the stakeholder (ISO 3166-1 alpha-2 codes) */
  readonly nationalities: readonly string[];
  /** Whether the stakeholder is a US person (FATCA compliance) */
  readonly usPerson?:
    | boolean
    | null
    | undefined;
  /** Whether the stakeholder has declared themselves as a politically exposed person */
  readonly selfPepDeclaration?:
    | boolean
    | null
    | undefined;
  /** The tax identification number in a country other than the legal country */
  readonly otherTaxIdentificationNumber?:
    | string
    | null
    | undefined;
  /** The tax residency country other than the legal country (ISO 3166-1 alpha-2) */
  readonly otherTaxResidencyCountry?:
    | string
    | null
    | undefined;
  /** The US tax identification number */
  readonly usTaxIdentificationNumber?:
    | string
    | null
    | undefined;
  /** The UBO connection to the organization */
  readonly uboConnectionToOrganization?:
    | string
    | null
    | undefined;
  /** The raw UBO connection to the organization */
  readonly uboConnectionToOrganizationRaw?:
    | string
    | null
    | undefined;
  /** Countries where the stakeholder has significant relationships (ISO 3166-1 alpha-2 codes) */
  readonly countriesOfSignificantRelationship: readonly string[];
  /** Country of predominant economic activity (ISO 3166-1 alpha-2) */
  readonly countryOfPredominantEconomicActivity?: string | null | undefined;
}

/** Error codes for CreateStakeholder operation */
export interface ApiCreateStakeholderErrors {
}

/** Bad request error codes */
export const ApiCreateStakeholderErrorsBadRequestError = {
  /** BAD_REQUEST_ERROR_UNSPECIFIED - Unspecified bad request error */
  BAD_REQUEST_ERROR_UNSPECIFIED: "BAD_REQUEST_ERROR_UNSPECIFIED",
  /** BAD_REQUEST_ERROR_VALIDATION_FAILED - Validation failed */
  BAD_REQUEST_ERROR_VALIDATION_FAILED: "BAD_REQUEST_ERROR_VALIDATION_FAILED",
} as const;

export type ApiCreateStakeholderErrorsBadRequestError =
  typeof ApiCreateStakeholderErrorsBadRequestError[keyof typeof ApiCreateStakeholderErrorsBadRequestError];

export namespace ApiCreateStakeholderErrorsBadRequestError {
  export type BAD_REQUEST_ERROR_UNSPECIFIED =
    typeof ApiCreateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  export type BAD_REQUEST_ERROR_VALIDATION_FAILED =
    typeof ApiCreateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED;
}

export function apiCreateStakeholderErrorsBadRequestErrorFromJSON(
  object: any,
): ApiCreateStakeholderErrorsBadRequestError {
  switch (object) {
    case 0:
    case "BAD_REQUEST_ERROR_UNSPECIFIED":
      return ApiCreateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
    case 1:
    case "BAD_REQUEST_ERROR_VALIDATION_FAILED":
      return ApiCreateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED;
    default:
      return ApiCreateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  }
}

export function apiCreateStakeholderErrorsBadRequestErrorToJSON(
  object: ApiCreateStakeholderErrorsBadRequestError,
): string {
  switch (object) {
    case ApiCreateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
    case ApiCreateStakeholderErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED:
      return "BAD_REQUEST_ERROR_VALIDATION_FAILED";
    default:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
  }
}

export const ApiCreateStakeholderRequest: MessageFns<ApiCreateStakeholderRequest> = {
  fromJSON(object: any): ApiCreateStakeholderRequest {
    return { stakeholder: isSet(object.stakeholder) ? ApiStakeholderInput.fromJSON(object.stakeholder) : null };
  },

  toJSON(message: ApiCreateStakeholderRequest): unknown {
    const obj: any = {};
    if (message.stakeholder !== undefined && message.stakeholder !== null) {
      obj.stakeholder = ApiStakeholderInput.toJSON(message.stakeholder);
    }
    return obj;
  },
};

export const ApiCreateStakeholderResponse: MessageFns<ApiCreateStakeholderResponse> = {
  fromJSON(object: any): ApiCreateStakeholderResponse {
    return { stakeholder: isSet(object.stakeholder) ? ApiStakeholder.fromJSON(object.stakeholder) : null };
  },

  toJSON(message: ApiCreateStakeholderResponse): unknown {
    const obj: any = {};
    if (message.stakeholder !== undefined && message.stakeholder !== null) {
      obj.stakeholder = ApiStakeholder.toJSON(message.stakeholder);
    }
    return obj;
  },
};

export const ApiStakeholderInput: MessageFns<ApiStakeholderInput> = {
  fromJSON(object: any): ApiStakeholderInput {
    return {
      organizationId: isSet(object.organization_id) ? globalThis.String(object.organization_id) : null,
      title: isSet(object.title) ? globalThis.String(object.title) : null,
      gender: isSet(object.gender) ? apiGenderFromJSON(object.gender) : null,
      firstName: isSet(object.first_name) ? globalThis.String(object.first_name) : null,
      lastName: isSet(object.last_name) ? globalThis.String(object.last_name) : null,
      email: isSet(object.email) ? globalThis.String(object.email) : null,
      phoneNumber: isSet(object.phone_number) ? globalThis.String(object.phone_number) : null,
      locale: isSet(object.locale) ? globalThis.String(object.locale) : null,
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : null,
      birthdate: isSet(object.birthdate) ? fromJsonTimestamp(object.birthdate) : null,
      addressLine1: isSet(object.address_line_1) ? globalThis.String(object.address_line_1) : null,
      addressLine2: isSet(object.address_line_2) ? globalThis.String(object.address_line_2) : null,
      addressZipcode: isSet(object.address_zipcode) ? globalThis.String(object.address_zipcode) : null,
      addressCity: isSet(object.address_city) ? globalThis.String(object.address_city) : null,
      addressCountry: isSet(object.address_country) ? globalThis.String(object.address_country) : null,
      birthZipcode: isSet(object.birth_zipcode) ? globalThis.String(object.birth_zipcode) : null,
      birthCity: isSet(object.birth_city) ? globalThis.String(object.birth_city) : null,
      birthCountry: isSet(object.birth_country) ? globalThis.String(object.birth_country) : null,
      nationality: isSet(object.nationality) ? globalThis.String(object.nationality) : null,
      role: isSet(object.role) ? apiRoleFromJSON(object.role) : null,
      shareholder: isSet(object.shareholder) ? globalThis.Boolean(object.shareholder) : null,
      capitalAmountCents: isSet(object.capital_amount_cents) ? globalThis.Number(object.capital_amount_cents) : null,
      gavePower: isSet(object.gave_power) ? globalThis.Boolean(object.gave_power) : null,
      powered: isSet(object.powered) ? globalThis.Boolean(object.powered) : null,
      ubo: isSet(object.ubo) ? globalThis.Boolean(object.ubo) : null,
      corporateOfficer: isSet(object.corporate_officer) ? globalThis.Boolean(object.corporate_officer) : null,
      italianFiscalCode: isSet(object.italian_fiscal_code) ? globalThis.String(object.italian_fiscal_code) : null,
      usTaxPayer: isSet(object.us_tax_payer) ? globalThis.Boolean(object.us_tax_payer) : null,
      taxPayerOutsideLegalCountry: isSet(object.tax_payer_outside_legal_country)
        ? globalThis.Boolean(object.tax_payer_outside_legal_country)
        : null,
      domicileSameAsResidence: isSet(object.domicile_same_as_residence)
        ? globalThis.Boolean(object.domicile_same_as_residence)
        : null,
      domicileLine1: isSet(object.domicile_line_1) ? globalThis.String(object.domicile_line_1) : null,
      domicileLine2: isSet(object.domicile_line_2) ? globalThis.String(object.domicile_line_2) : null,
      domicileZipcode: isSet(object.domicile_zipcode) ? globalThis.String(object.domicile_zipcode) : null,
      domicileCity: isSet(object.domicile_city) ? globalThis.String(object.domicile_city) : null,
      domicileCountry: isSet(object.domicile_country) ? globalThis.String(object.domicile_country) : null,
      sourcesOfWealth: globalThis.Array.isArray(object?.sources_of_wealth)
        ? object.sources_of_wealth.map((e: any) => globalThis.String(e))
        : [],
      sourcesOfWealthOther: isSet(object.sources_of_wealth_other)
        ? globalThis.String(object.sources_of_wealth_other)
        : null,
      hasSourcesOfWealth: isSet(object.has_sources_of_wealth) ? globalThis.Boolean(object.has_sources_of_wealth) : null,
      politicallyExposedPerson: isSet(object.politically_exposed_person)
        ? globalThis.Boolean(object.politically_exposed_person)
        : null,
      nationalities: globalThis.Array.isArray(object?.nationalities)
        ? object.nationalities.map((e: any) => globalThis.String(e))
        : [],
      usPerson: isSet(object.us_person) ? globalThis.Boolean(object.us_person) : null,
      selfPepDeclaration: isSet(object.self_pep_declaration) ? globalThis.Boolean(object.self_pep_declaration) : null,
      otherTaxIdentificationNumber: isSet(object.other_tax_identification_number)
        ? globalThis.String(object.other_tax_identification_number)
        : null,
      otherTaxResidencyCountry: isSet(object.other_tax_residency_country)
        ? globalThis.String(object.other_tax_residency_country)
        : null,
      usTaxIdentificationNumber: isSet(object.us_tax_identification_number)
        ? globalThis.String(object.us_tax_identification_number)
        : null,
      uboConnectionToOrganization: isSet(object.ubo_connection_to_organization)
        ? globalThis.String(object.ubo_connection_to_organization)
        : null,
      uboConnectionToOrganizationRaw: isSet(object.ubo_connection_to_organization_raw)
        ? globalThis.String(object.ubo_connection_to_organization_raw)
        : null,
      countriesOfSignificantRelationship: globalThis.Array.isArray(object?.countries_of_significant_relationship)
        ? object.countries_of_significant_relationship.map((e: any) => globalThis.String(e))
        : [],
      countryOfPredominantEconomicActivity: isSet(object.country_of_predominant_economic_activity)
        ? globalThis.String(object.country_of_predominant_economic_activity)
        : null,
    };
  },

  toJSON(message: ApiStakeholderInput): unknown {
    const obj: any = {};
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organization_id = message.organizationId;
    }
    if (message.title !== undefined && message.title !== null) {
      obj.title = message.title;
    }
    if (message.gender !== undefined && message.gender !== null) {
      obj.gender = apiGenderToJSON(message.gender);
    }
    if (message.firstName !== undefined && message.firstName !== null) {
      obj.first_name = message.firstName;
    }
    if (message.lastName !== undefined && message.lastName !== null) {
      obj.last_name = message.lastName;
    }
    if (message.email !== undefined && message.email !== null) {
      obj.email = message.email;
    }
    if (message.phoneNumber !== undefined && message.phoneNumber !== null) {
      obj.phone_number = message.phoneNumber;
    }
    if (message.locale !== undefined && message.locale !== null) {
      obj.locale = message.locale;
    }
    if (message.timezone !== undefined && message.timezone !== null) {
      obj.timezone = message.timezone;
    }
    if (message.birthdate !== undefined && message.birthdate !== null) {
      obj.birthdate = message.birthdate.toISOString();
    }
    if (message.addressLine1 !== undefined && message.addressLine1 !== null) {
      obj.address_line_1 = message.addressLine1;
    }
    if (message.addressLine2 !== undefined && message.addressLine2 !== null) {
      obj.address_line_2 = message.addressLine2;
    }
    if (message.addressZipcode !== undefined && message.addressZipcode !== null) {
      obj.address_zipcode = message.addressZipcode;
    }
    if (message.addressCity !== undefined && message.addressCity !== null) {
      obj.address_city = message.addressCity;
    }
    if (message.addressCountry !== undefined && message.addressCountry !== null) {
      obj.address_country = message.addressCountry;
    }
    if (message.birthZipcode !== undefined && message.birthZipcode !== null) {
      obj.birth_zipcode = message.birthZipcode;
    }
    if (message.birthCity !== undefined && message.birthCity !== null) {
      obj.birth_city = message.birthCity;
    }
    if (message.birthCountry !== undefined && message.birthCountry !== null) {
      obj.birth_country = message.birthCountry;
    }
    if (message.nationality !== undefined && message.nationality !== null) {
      obj.nationality = message.nationality;
    }
    if (message.role !== undefined && message.role !== null) {
      obj.role = apiRoleToJSON(message.role);
    }
    if (message.shareholder !== undefined && message.shareholder !== null) {
      obj.shareholder = message.shareholder;
    }
    if (message.capitalAmountCents !== undefined && message.capitalAmountCents !== null) {
      obj.capital_amount_cents = Math.round(message.capitalAmountCents);
    }
    if (message.gavePower !== undefined && message.gavePower !== null) {
      obj.gave_power = message.gavePower;
    }
    if (message.powered !== undefined && message.powered !== null) {
      obj.powered = message.powered;
    }
    if (message.ubo !== undefined && message.ubo !== null) {
      obj.ubo = message.ubo;
    }
    if (message.corporateOfficer !== undefined && message.corporateOfficer !== null) {
      obj.corporate_officer = message.corporateOfficer;
    }
    if (message.italianFiscalCode !== undefined && message.italianFiscalCode !== null) {
      obj.italian_fiscal_code = message.italianFiscalCode;
    }
    if (message.usTaxPayer !== undefined && message.usTaxPayer !== null) {
      obj.us_tax_payer = message.usTaxPayer;
    }
    if (message.taxPayerOutsideLegalCountry !== undefined && message.taxPayerOutsideLegalCountry !== null) {
      obj.tax_payer_outside_legal_country = message.taxPayerOutsideLegalCountry;
    }
    if (message.domicileSameAsResidence !== undefined && message.domicileSameAsResidence !== null) {
      obj.domicile_same_as_residence = message.domicileSameAsResidence;
    }
    if (message.domicileLine1 !== undefined && message.domicileLine1 !== null) {
      obj.domicile_line_1 = message.domicileLine1;
    }
    if (message.domicileLine2 !== undefined && message.domicileLine2 !== null) {
      obj.domicile_line_2 = message.domicileLine2;
    }
    if (message.domicileZipcode !== undefined && message.domicileZipcode !== null) {
      obj.domicile_zipcode = message.domicileZipcode;
    }
    if (message.domicileCity !== undefined && message.domicileCity !== null) {
      obj.domicile_city = message.domicileCity;
    }
    if (message.domicileCountry !== undefined && message.domicileCountry !== null) {
      obj.domicile_country = message.domicileCountry;
    }
    if (message.sourcesOfWealth?.length) {
      obj.sources_of_wealth = message.sourcesOfWealth;
    }
    if (message.sourcesOfWealthOther !== undefined && message.sourcesOfWealthOther !== null) {
      obj.sources_of_wealth_other = message.sourcesOfWealthOther;
    }
    if (message.hasSourcesOfWealth !== undefined && message.hasSourcesOfWealth !== null) {
      obj.has_sources_of_wealth = message.hasSourcesOfWealth;
    }
    if (message.politicallyExposedPerson !== undefined && message.politicallyExposedPerson !== null) {
      obj.politically_exposed_person = message.politicallyExposedPerson;
    }
    if (message.nationalities?.length) {
      obj.nationalities = message.nationalities;
    }
    if (message.usPerson !== undefined && message.usPerson !== null) {
      obj.us_person = message.usPerson;
    }
    if (message.selfPepDeclaration !== undefined && message.selfPepDeclaration !== null) {
      obj.self_pep_declaration = message.selfPepDeclaration;
    }
    if (message.otherTaxIdentificationNumber !== undefined && message.otherTaxIdentificationNumber !== null) {
      obj.other_tax_identification_number = message.otherTaxIdentificationNumber;
    }
    if (message.otherTaxResidencyCountry !== undefined && message.otherTaxResidencyCountry !== null) {
      obj.other_tax_residency_country = message.otherTaxResidencyCountry;
    }
    if (message.usTaxIdentificationNumber !== undefined && message.usTaxIdentificationNumber !== null) {
      obj.us_tax_identification_number = message.usTaxIdentificationNumber;
    }
    if (message.uboConnectionToOrganization !== undefined && message.uboConnectionToOrganization !== null) {
      obj.ubo_connection_to_organization = message.uboConnectionToOrganization;
    }
    if (message.uboConnectionToOrganizationRaw !== undefined && message.uboConnectionToOrganizationRaw !== null) {
      obj.ubo_connection_to_organization_raw = message.uboConnectionToOrganizationRaw;
    }
    if (message.countriesOfSignificantRelationship?.length) {
      obj.countries_of_significant_relationship = message.countriesOfSignificantRelationship;
    }
    if (
      message.countryOfPredominantEconomicActivity !== undefined &&
      message.countryOfPredominantEconomicActivity !== null
    ) {
      obj.country_of_predominant_economic_activity = message.countryOfPredominantEconomicActivity;
    }
    return obj;
  },
};

export const ApiCreateStakeholderErrors: MessageFns<ApiCreateStakeholderErrors> = {
  fromJSON(_: any): ApiCreateStakeholderErrors {
    return {};
  },

  toJSON(_: ApiCreateStakeholderErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
